<div class="panel">
    <div class="title">{{ "dashboardConfiguration.title" | t }}</div>
    <div class="configurations">
        <div class="form-group">
            <label>{{ "dashboardConfiguration.nameLabel" | t }}</label>
            <cerrix-textfield
                [placeholder]="'dashboardConfiguration.namePlaceholder' | t"
                data-uiid="dashboard-configuration-name"
                [(ngModel)]="config.name"
            ></cerrix-textfield>
        </div>

        <div class="form-group">
            <label>{{ "dashboardConfiguration.descriptionLabel" | t }}</label>
            <cerrix-textarea [(ngModel)]="config.description"></cerrix-textarea>
        </div>

        <div class="form-group">
            <label>{{ "dashboardConfiguration.iconLabel" | t }}</label>
            <cerrix-icon-picker [(value)]="config.icon"></cerrix-icon-picker>
        </div>

        <div class="row">
            <div class="col">
                <cerrix-checkbox
                    [(value)]="config.default"
                    (valueChange)="defaultChanged($event)"
                    [label]="'dashboardConfiguration.personalDefaultLabel' | t"
                    data-uiid="dashboard-configuration-personal-default"
                ></cerrix-checkbox>
            </div>
            <div class="col">
                <cerrix-checkbox
                    [(value)]="config.favorite"
                    [disabled]="config.default"
                    [label]="'dashboardConfiguration.favoriteLabel' | t"
                    data-uiid="dashboard-configuration-favorite"
                ></cerrix-checkbox>
            </div>
        </div>

        @if (
            permissions.RoleGroupLinker || permissions.SystemDefaultSetter || permissions.Publisher
        ) {
            <hr />
        }

        @if (permissions.RoleGroupLinker) {
            <div class="form-group">
                <label>{{ "dashboardConfiguration.roleGroupLabel" | t }}</label>
                <ng-select
                    id="executableSelect"
                    name="executableSelect"
                    [items]="roleGroups"
                    [(ngModel)]="config.roleGroups"
                    bindLabel="Name"
                    bindValue="ID"
                    [closeOnSelect]="false"
                    [multiple]="true"
                    [clearable]="true"
                    [loading]="!roleGroups"
                >
                </ng-select>
            </div>
        }

        <div class="row">
            @if (permissions.SystemDefaultSetter) {
                <div class="col">
                    <cerrix-checkbox
                        [(value)]="config.systemDefault"
                        (valueChange)="defaultChanged($event)"
                        [label]="'dashboardConfiguration.systemDefaultLabel' | t"
                        data-uiid="dashboard-configuration-system-default"
                    ></cerrix-checkbox>
                </div>
            }
            @if (permissions.Publisher) {
                <div class="col">
                    <cerrix-checkbox
                        [(value)]="config.public"
                        (valueChange)="defaultChanged($event)"
                        [label]="'dashboardConfiguration.makePublicLabel' | t"
                        data-uiid="dashboard-configuration-make-public"
                    ></cerrix-checkbox>
                    <i
                        class="fas fa-info-circle ms-2"
                        [matTooltip]="'dashboardConfiguration.publicInfoTooltip' | t"
                    ></i>
                </div>
            }
        </div>
    </div>
</div>
